// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { InfoContainer as _InfoContainer } from "metabase/common/components/MetadataInfo/MetadataInfo.styled";

export const Small = styled.div`
  font-size: 0.9em;
`;

export const InfoContainer = styled(_InfoContainer)`
  gap: 0.8em;
`;
